import ANLogo from "@/assets/logo/Logo.png";

export const DIGIO_ENV = "production";

export const DIGIO_BRAND = {
  logo: ANLogo,
  theme: {
    primaryColor: "#AB3498",
    secondaryColor: "#000000"
  }
};

export const KYC_CREATE_ENDPOINT = "/api/kyc/digio/create";
